import { normalizeMarkdown } from './normalizeMarkdown';

/**
 * Canonicalizes a markdown string through the same pipeline the Tiptap editor
 * applies on open, so two texts that differ only by the editor's deterministic
 * reformatting (heading / blank-line spacing the v3 serializer can't
 * byte-preserve) compare as identical. Falls back to the raw input if
 * normalization fails.
 *
 * This is the single source of truth for "normalize before comparing": the
 * Levenshtein score (api-nest ContentSimilarityService) and the admin diff
 * (review-dash normalizeForDiff) both call it, so the score and the diff can
 * never drift apart — which is exactly the phantom-diff class this work targets.
 * See ENG-4453.
 */
export const normalizeMarkdownForComparison = (
  text: string | undefined | null,
): string => {
  const input = text ?? '';
  const result = normalizeMarkdown({ markdown: input });
  return result.ok ? result.result : input;
};
